










































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';
import { HeaderList } from '@/components/Table/TableModel';
import { upperCaseFirstLetter } from '@/utils/string';

@Component({
  components: {
    Typography,
    Table,
    TableCell,
    TableHeader,
    TableRow,
    TableCard,
    EmptyStateTable
  }
})
export default class MemberList extends Vue {
  @Prop() headers!: HeaderList[];
  @Prop() data!: any[];
  @Prop() sortField!: string[];
  @Prop() sortOrder!: string;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  upperCaseFirstLetter(text: string) {
    return upperCaseFirstLetter(text);
  }

  statusLabel(status: string) {
    const key = `offers.detail.members.status.${status}`;
    return this.$te(key, 'en-US') ? this.$t(key) : status;
  }

  isActiveStatus(status: string) {
    return status === 'active';
  }
}
